import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './LanguageContext';
import LandingPage from './pages/LandingPage';
import RegistrationPage from './pages/RegistrationPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AttendanceSheetPage from './pages/AttendanceSheetPage';
import UploadAttendancePage from './pages/UploadAttendancePage';
import OnlineAttendancePage from './pages/OnlineAttendancePage';
import UsersPage from './pages/UsersPage';
import MembershipPage from './pages/MembershipPage';
import VerifierLoginPage from './pages/VerifierLoginPage';
import VerifyMemberPage from './pages/VerifyMemberPage';
import { captureUTM } from './utils/utm';

function App() {
  useEffect(() => {
    captureUTM();
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter basename="/learningcenter">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/register" element={<RegistrationPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/attendance-sheet" element={<AttendanceSheetPage />} />
          <Route path="/upload-attendance" element={<UploadAttendancePage />} />
          <Route path="/online-attendance" element={<OnlineAttendancePage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/membership" element={<MembershipPage />} />
          <Route path="/verifier-login" element={<VerifierLoginPage />} />
          <Route path="/verify" element={<VerifyMemberPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
